<template>
  <outlined-block title="Default scheduling information">
    <v-container fluid>
      <v-row align="center">
        <v-col cols="8" sm="6">
          <duration-picker label="Duration" dense hide-details v-model="planning.specifiedDuration" :disabled="planning.useAverageDuration"/>
        </v-col>
        <v-col v-if="!!durationPerUnit" cols="4" sm="2">
          per {{durationPerUnit}}
        </v-col>
        <v-col cols="6" sm="4">
          <v-checkbox label="Use average" v-model="planning.useAverageDuration"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-select multiple label="Equipment" outlined hide-details
                    :items="equipment" item-text="name" item-value="id" v-model="equipmentUsed">
            <template v-slot:item="{item,on,attrs}">
              <v-list-item>
                <v-container class="pa-0">
                  <v-row align="center">
                    <v-col cols="7" sm="7" lg="7" >
                      {{item.name}}
                    </v-col>
                    <v-col cols="5" sm="3" lg="2">
                      <decimal-number-input v-model="item.quantity" prefix="x" :precision="0" :outlined="false" dense hide-details integer :min="0" @change="equipmentChange(item)"/>
                    </v-col>
                  </v-row>
                </v-container>
              </v-list-item>
            </template>
            <template v-slot:selection="{item,selected}">
              <v-chip>{{item.quantity}} x {{item.name}}</v-chip>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-row class="mt-4 mb-1">
        <v-col cols="12">
          <v-select label="Perform by role" :items="roles" item-text="name" item-value="id" dense outlined hide-details v-model="planning.roleId">
            <template v-slot:prepend-item>
              <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="createRole=true">
                <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new role
              </div>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-container>

    <planning-scheduling-roles-crupdate v-model="createRole" @create="createdRole($event)"/>
  </outlined-block>
</template>

<script>
import PlanningSchedulingRolesCrupdate from '@/views/planning/scheduling/PlanningSchedulingRolesCrupdate'

export default {
  name: 'ProductionPlanning',
  props: {
    planning: {type:Object, required:true},
    durationPerUnit: {type:String, required:false}
  },
  components: {PlanningSchedulingRolesCrupdate},
  data() {
    return {
      equipment: [],
      roles: [],
      equipmentUsed: [],
      createRole: false
    }
  },
  watch: {
    planning() {
      this.initEquipmentUsed();
    }
  },
  async created() {
    const equipmentTypes = [];
    await this.$lazyListLoad(equipmentTypes, 'equipmentTypes2', 'id,name', 100, [], [{name:'includeDefault',value:'1'}]);

    const results = await this.$apiCall(`query ProductionPlanning {
                                            roles {id,name}
                                          }`, {});
    this.equipment = equipmentTypes.map(type => ({...type,quantity:0}));
    this.roles = [{name:'(none)',id:''},{divider:true},...results.data.roles];
    this.initEquipmentUsed();
  },
  methods: {
    createdRole(role) {
      this.roles.push(role);
      this.planning.roleId = role.id;
    },
    initEquipmentUsed() {
      if (this.equipment.length === 0)
        return;
      for (const equipmentType of this.planning.equipmentTypes) {
        this.equipment.find(equipment => equipment.id === equipmentType.id).quantity = equipmentType.quantity;
        if (equipmentType.quantity)
          this.equipmentUsed.push(equipmentType.id);
      }
    },
    equipmentChange(item) {
      if (item.quantity) {
        const plannedType = this.planning.equipmentTypes.find(type => type.id === item.id);
        if (plannedType)
          plannedType.quantity = item.quantity;
        else
          this.planning.equipmentTypes.push({id:item.id, quantity:item.quantity});
      }
      else {
        const index = this.planning.equipmentTypes.findIndex(type => type.id === item.id);
        if (index !== -1)
          this.planning.equipmentTypes.splice(index, 1);
      }
      this.equipmentUsed = this.equipment.filter(equipment => equipment.quantity).map(equipment => equipment.id);
    }
  }
}
</script>